<template>
  <div class="search">
    <div class="main">
      <el-input v-model="input" id="search_btn" :placeholder='$t("page.placeHoder")' @focus="enableKeyboard(false)" @blur="enableKeyboard(true)" size="mini" @keyup.enter.native="search">
        <!-- <el-button slot="prefix" class="btn1" icon="el-icon-search"></el-button> -->
        <i slot="prefix" class="el-icon-search el-input__icon"></i>
      </el-input>
    </div>
    <div v-if="hasResult" class="cont">
      <div v-if="info.bitNumberData" class="info-title">
        <div> {{ $t('tagSearch.tagSearch') }}<i>&nbsp;({{ info.bitNumberData.length }})</i></div><i @click="hasResult = false,input = ''" class="el-icon-close"></i>
      </div>
      <div class="info-list scrollbar">
        <div class="com datas" v-if="info.bitNumberData">
          <div class="data-info" :class="currentIndex === index? 'active': ''" v-for="(i, index) in info.bitNumberData" :key="index">
            <div class="info-left">
              <span @click="selectPos(i), currentIndex = index">{{i.bitNumber}}</span>
            </div>
            <div class="info-right">
              <span>{{i.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hasResult && !info && input" class="cont">
      <p class="empty-info">
        {{ $t('docMgt.noData') }}
      </p>
    </div>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
import '@/common/css/scrollbar.css'
export default {
  name: 'search',
  data() {
    return {
      hasResult: false,
      input: '',
      info: [],
      tagBaseConfig: {
        'kpa': { color: '#F5B731', img: '1.png' },
        '℃': { color: '#F5B731', img: '1.png' },
        '%': { color: '#F42C33', img: '3.png' },
        'r/m': { color: '#F42C33', img: '3.png' },
        'm3/d': { color: '#3183F5', img: '2.png' }
      },
      selectTag: [],
      allNumber: 0,
      currentIndex: null
    }
  },
  created() {
    // this.$bus.$on('closeSearchPanel',this.cancle)
  },
  watch:{
    input(val){
      if (!val) {
        this.hasResult = false
        window.ResetAllElement()
        return
      }
      let _this = this
      setTimeout(() => {
        this.search()
      }, 500)
    }
  },
  methods: {
    enableKeyboard(val) {
      window.SetKeyBoardEnable(val)
      if (val) {
        // this.$store.commit('closeModal', 'attrs')
        this.$store.commit('syncAttrData', null)
      }
    },
    cancle() {
      // window.resetView()
      this.hideAllTag()
      this.hasResult = false
      this.$store.commit('closeModal', 'search')
    },
    search() {
      ApiService.doc
        .fileSearch({
          SearchKey: this.input,
          mileageID: window.R_config.modelId
        })
        .then(res => {
          if (res.code === 0) {
            this.info = res.data
            this.hasResult = true
            let a = this.info.realData? this.info.realData.length: 0
            let b = this.info.docData? this.info.docData.length: 0
            let c = this.info.realData? this.info.realData.length: 0
            let d = this.info.bitNumberData? this.info.bitNumberData.length: 0
            this.allNumber = a + b + c + d
          } else {
            this.hasResult = false
            this.info = ''
          }
        })
    },
    hideAllTag() {
      window.markerArray.forEach(ele => {
        window.RemoveMarker(ele)
      })
      window.markerArray = []
    },
    selectPos(row, index) {
      this.currentIndex = index
      ApiService.doc
        .getModelData({
          glid: '',
          bitNumber: row.devicen || row.bitNumber,
          mileageID: window.R_config.modelId
        })
        .then(res => {
          let glids = ''
          if (res.data.glid.length > 1) {
            glids = res.data.glid.join('#')
          } else {
            glids = res.data.glid[0]
          }
          if (window.PData) window.PData.data.id = glids
          window.Muster = res.data.bitNumber
          this.addLabel(row, glids, res.data.bitNumber)
        })
    },
    addLabel(row, glids, bit) {
      window.ResetAllElement()
      window.elementType = 0
      window.currentElement = glids
      window.FlyTo(glids, true, 2.8)
      this.getproperty(bit)
    },
    getproperty(bit) {
      ApiService.tree
        .property({
          mileageID: window.R_config.modelId,
          bitNumber: bit
        })
        .then(res => {
          if (res.code == 0) {
            let attrData = res.data
            this.$store.commit('syncAttrData', attrData)
            this.$store.commit('showModal', {
              name: 'attrs',
              show: true
            })
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  position: relative;
  .main {
    width: 260px;
    border-radius: 4px;
    ::v-deep {
      .el-input__suffix {
        display: flex;
        align-items: center;
        background-color: transparent;
      }
      .el-input-group__append{
        background-color:#fff;
        border: none;
        display: inline-flex;
        height: 28px;
        align-items: center;
      }
      .el-input {
        .el-input__inner {
          border-radius: 4px;
          border-right: 0;
          border: 0;
          background-color: #fff;
          color: #000;
        }
      }
      .el-button {
        padding: 0;
        font-size: 18px;
        border: 0;
        border-radius: 0;
        display: flex;
        margin-left: -7px;
        color: rgb(196,224,246);
        background-color:#fff;
      }
    }
  }
  .cont {
    color: #333;
    width: 260px;
    position: absolute;
    background: #fff;
    top: 43px;
    left: 180px;
    border-radius: 4px;
    box-shadow: 0px 1px 6px 0px rgba(28, 28, 28, 0.14);
    z-index: 9999;
    .empty-info {
      font-size: 14px;
      color: #ccc;
      text-align: center;
    }
    .info-title {
      height: 38px;
      line-height: 38px;
      padding: 0 16px;
      font-size: 16px;
      text-align: left;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      >div {
        i {
          font-size: 14px;
          font-style: normal;
          color: #999;
        }
      }
      .el-icon-close {
        cursor: pointer;
        &:hover {
          color: #7cb1da;
        }
      }
    }
    .info-list {
      height: 500px;
      overflow: auto;
      .com {
        .child-title {
          display: flex;
          justify-content: space-between;
          text-align: left;
          align-items: center;
          padding: 0 16px;
          background: #f5f5f5;
          span {
            display: block;
            height: 30px;
            line-height: 30px;
            i {
              font-size: 12px;
              font-style: normal;
              color: #999;
            }
          }
          i {
            cursor: pointer;
          }
        }
        .active {
          color: #0078d7;
          background: #e0edf8;
        }
        .data-info {
          padding: 5px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 16px;
          &:hover {
            background: #f4f9fd;
          }
          .info-left {
            display: flex;
            flex-direction: column;
            span {
              color: #333;
              display: flex;
              align-items: center;
              cursor: pointer;
              i {
                display: block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background: #8ebd5d;
                margin-right: 8px;
              }
            }
            b {
              display: block;
              color: #999;
              font-size: 12px;
              margin-top: 5px;
            }
          }
          .info-right {
            display: block;
            color: #666;
          }
        }
        .file-info {
          padding: 5px 16px;
          &:hover {
            background: #f4f9fd;
          }
          .file-top {
            text-align: left;
            margin-bottom: 5px;
            cursor: pointer;
          }
          .file-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            color: #999;
            span {
              text-align: left;
            }
            span,
            i {
              display: block;
              font-style: normal;
            }
          }
        }
        .video-info {
          padding: 10px 16px;
          text-align: left;
          p {
            color: #666;
          }
          span {
            display: block;
            margin-top: 5px;
            color: #999;
            font-size: 12px;
          }
          &:hover {
            background: #f4f9fd;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/search.vue